module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic.4595d7f8ce0e7b381abb.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.ttf
// module id = ../../../../npm-font-open-sans/fonts/ExtraBoldItalic/OpenSans-ExtraBoldItalic.ttf
// module chunks = styles